import React from 'react';
import { PortfolioSidebar } from '../page-portfolio/PortfolioParts';

function PortfolioDetail({ item, allItems }) {
  if (!item) {
    return (
      <section className="blog section-padding">
        <div className="container text-center">
          <h4>Proje bulunamadı.</h4>
          <a href="/portfolio" className="main-color mt-30 d-inline-block">
            Portfolio&apos;ya Dön
          </a>
        </div>
      </section>
    );
  }

  const paragraphs = (item.content || item.excerpt || '').split('\n').filter(Boolean);

  return (
    <section className="blog section-padding">
      <div className="container">
        <div className="row xlg-marg">
          <div className="col-lg-8">
            <div className="main-post">
              <div className="item pb-60">
                <article>
                  {paragraphs.map((para, i) => (
                    <div key={i} className={`text ${i > 0 ? 'mt-20' : ''}`}>
                      {i === 0 ? (
                        <p>
                          <span className="spec-letter">{para.charAt(0)}</span>
                          {para.slice(1)}
                        </p>
                      ) : (
                        <p>{para}</p>
                      )}
                    </div>
                  ))}
                </article>
              </div>
              <div className="info-area flex pt-50 bord-thin-top">
                <div>
                  <div className="tags flex">
                    <div className="valign">
                      <span>Kategori :</span>
                    </div>
                    <div>
                      <a href="/portfolio">{item.category}</a>
                    </div>
                  </div>
                </div>
                <div className="ml-auto">
                  {item.url && (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center main-color"
                    >
                      <span className="text mr-10">Canlı Siteyi Gör</span>
                      <span className="ti-arrow-top-right"></span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <PortfolioSidebar items={allItems} currentId={item.id} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PortfolioDetail;
